import { LicenseDTOV1 } from '../swagger-api-v1';

export class License {
  constructor(
    public used = 0,
    public available = 0,
    public total = 0
  ) {}

  public static fromDTO(dto: LicenseDTOV1): License {
    return new License(dto.capacity - dto.available, dto.available, dto.capacity);
  }
}
